import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import AccountReorderActions from '../actions/AccountReorderActions';
import AccountsActionCreator from '../actions/AccountsActionCreator';

const _accountReorderEndPoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/attributes';

class AccountReorderApiUtils {
  /*
   ** api call to get the preferences
   */
  static setAccountReorderCall(requestPacket) {
    const requestData = JSON.stringify(requestPacket);
    const url = envConfig.apiBaseUrlPAAS + _accountReorderEndPoint;
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.setStatementPreferences,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        AccountReorderActions.nextReorderBatchCall(body);
      },
      (error) => {
        AccountsActionCreator.handleAccountOrderChangesError(error);
      }
    );
  }

  static updateAccountsStore(response) {
    AccountsActionCreator.updateAccountsStore(response);
  }

  // Update UI and sort the account list .
  // reordering is sucess now
  static udpateUI() {
    AccountsActionCreator.sortAccountList();
  }
}

export default AccountReorderApiUtils;
